import { SVGProps, Ref, forwardRef } from 'react';

export const ListShortOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M3 9.833c.295 0 .444.095.525.193.09.11.142.274.142.474l-.01.144a.65.65 0 0 1-.132.33c-.081.098-.23.193-.525.193s-.444-.095-.525-.193c-.09-.11-.142-.274-.142-.474s.051-.365.142-.474c.081-.098.23-.193.525-.193Zm10.667.3v.733H5.833v-.732zM3 4.834c.295 0 .444.095.525.193.09.11.142.274.142.474s-.051.365-.142.474c-.081.098-.23.193-.525.193s-.444-.095-.525-.193c-.09-.11-.142-.274-.142-.474s.051-.365.142-.474c.081-.098.23-.193.525-.193Zm10.667.3v.734H5.833v-.733z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth={0.667}
            />
        </g>
    </svg>
));
ListShortOutlinedSize16Glyph.displayName = 'ListShortOutlinedSize16Glyph';
